import { render, staticRenderFns } from "./question.vue?vue&type=template&id=5c89ad0a&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=5c89ad0a&prod&scoped=true&lang=less&"
import style1 from "./question.vue?vue&type=style&index=1&id=5c89ad0a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89ad0a",
  null
  
)

export default component.exports